import filter from 'lodash/filter';
import isNumber from 'lodash/isNumber';
import { getDistanceFromLatLngInKm } from '@yme/utils/dealer';
function getSortedDataList(data) {
    return data.sort((a, b) => {
        if (a?.distance && b?.distance) {
            return a.distance - b.distance;
        }
        return 0;
    });
}
export function getFilteredDataList(data, coordinates) {
    const listData = data.map((item) => {
        const distance = getDistanceFromLatLngInKm({
            firstPairs: coordinates,
            secondPairs: {
                lat: item.latitude,
                lng: item.longitude,
            },
        });
        return {
            ...item,
            distance: distance ?? 0,
        };
    });
    return getSortedDataList(listData);
}
export const getDealersWithCoordinates = (dealersList) => filter(dealersList, ({ latitude, longitude }) => isNumber(latitude) && isNumber(longitude));
